module.exports = __webpack_public_path__ + "img/scanCodeWZ_background.538d58a0.png";